import React from 'react'

function Website() {
    return (
        <>
            <h2>Visit the Paradox Parlours website</h2>
            <button className="landing_btn">Find More Games!</button>
        </>
    )
}

export default Website